<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!groups.length" class="rm-empty">
      <template v-if="search">{{ $t("report_mobile.no_results_for", { search }) }}</template>
      <template v-else>
        <v-icon size="40" color="#8a817a">mdi-food-off</v-icon>
        {{ $t("no_orders") }}
      </template>
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.workers") }}</span>
          <span class="rm-stat__value rm-num">{{ workerTotal }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
        </div>
      </div>

      <section v-for="group in groups" :key="group.id" class="rm-ord-group">
        <div class="rm-ord-group__head">
          <report-shift-tag :shift="group.id" long></report-shift-tag>
          <i class="rm-ord-group__rule"></i>
          <span class="rm-num">{{ groupSummary(group) }}</span>
        </div>

        <ul class="rm-list rm-card">
          <li v-for="slip in group.slips" :key="slip.key" class="rm-ord-row" :data-shift="group.id">
            <span class="rm-avatar rm-avatar--lg">{{ slip.initials }}</span>
            <div class="rm-ord-row__body">
              <div class="rm-ord-row__top">
                <span class="rm-ord-row__name">{{ slip.name }}</span>
                <span v-if="slip.orderId && !isRange" class="rm-ord-row__no rm-num">#{{ slip.orderId }}</span>
              </div>
              <div v-for="(meal, index) in slip.meals" :key="index" class="rm-ord-row__meal">
                <b class="rm-num">{{ meal.total }}× </b>
                <span>{{ meal.name }}</span>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>

<script>
import CompanyReportTabOrders from "@/components/company/reports/companyTabs/companyReportTabOrders.vue";
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import hasCompanyOrderSlips from "../../hasCompanyOrderSlips";

/**
 * Mobilni "Naručeno" firme: po smenama spisak radnika sa obrocima koje su naručili. Smene, firme i period su
 * u zaglavlju, pretraga (po imenu radnika) u lupi. Nasleđuje učitavanje, štampu i Excel iz starog taba; podela
 * po smenama je u hasCompanyOrderSlips.
 */
export default {
  name: "CompanyMobileOrdered",
  extends: CompanyReportTabOrders,
  mixins: [hasCompanyOrderSlips],
  components: { ReportShiftTag },
};
</script>

<style lang="scss">
.rm-ord-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 4px 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--rm-muted);
  }

  &__rule {
    flex: 1;
    height: 1px;
    background: var(--rm-divider);
  }
}

.rm-ord-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--rm-divider-soft);

  &:last-child {
    border-bottom: none;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }

  &__name {
    min-width: 0;
    font-size: 15px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  &__no {
    flex: none;
    font-size: 12px;
    color: var(--rm-muted);
  }

  &__meal {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-top: 3px;
    font-size: 14px;
    line-height: 1.35;
    overflow-wrap: anywhere;

    b {
      flex: none;
      font-weight: 700;
    }
  }
}

@for $n from 1 through 4 {
  .rm-theme .rm-ord-row[data-shift="#{$n}"] .rm-avatar {
    background: var(--rm-shift-#{$n}-bg);
    color: var(--rm-shift-#{$n}-fg);
  }

  .rm-ord-row[data-shift="#{$n}"] .rm-ord-row__meal b {
    color: var(--rm-shift-#{$n}-fg);
  }
}
</style>
